import React from 'react';
import { Svelte } from '../utils/SvelteToReact';
import TooltipSvelte from '@glance-design/tooltip/Tooltip.svelte';

export const Tooltip = (props) => {
  const defineProps = {
    visible: props.visible,
    text: props.text,
    position: props.position,
    strategy: props.strategy,
    shift: props.shift || false,
    flip: props.flip || false,
    size: props.size,
    fadeDuration: props.fadeDuration,
    mouseenterTimeout: props.mouseenterTimeout,
    inline: props.inline || false,
    offset: props.offset,
  };

  return (
    <Svelte component={TooltipSvelte} {...defineProps}>
      {props.children}
    </Svelte>
  );
};
